import React, { useState } from "react";
import axios from "axios";
import useAuth from "../../../../hooks/useAuth";
import { BASE_URL } from "../../../../utils/Element";
import Modal from "../../../../components/Modal/Modal";
import { NotificationManager } from "react-notifications";

const AddLeadSourceModal = ({ showModal, onClose, onCallApi }) => {
  const [config] = useAuth();
  const [error, setError] = useState();
  const [disable, setDisable] = useState(false);
  const [data, setData] = useState({
    sourceName: "",
    category: "",
  });

  const handleChange = (value, name) => {
    setError({ ...error, [name]: "" });
    setData({ ...data, [name]: value });
  };

  const handleClose = () => {
    onClose();
    setDisable(false);
    setError();
    setData({
      sourceName: "",
      category: "",
    });
  };

  const handleSubmit = (e) => {
    setDisable(true);
    e.preventDefault();
    const dataToSend = {
      name: data?.sourceName,
    };
    axios
      .post(`${BASE_URL}/add-lead-source`, dataToSend, config)
      .then((res) => {
        onCallApi();
        handleClose();
        if (res?.data?.message) {
          NotificationManager.success(res?.data?.message);
        }
      })
      .catch((err) => {
        setError(err?.response?.data?.errors);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => {
        setDisable(false);
      });
  };

  return (
    <Modal title={"Add Lead Source"} desc={"This source will be accessible for any contact that is owned by Tri-Oak Consulting Group"} show={showModal} onClose={handleClose}>
      <form className="mt-3" onSubmit={handleSubmit}>
        <div>
          <label className="dark-H head-4 mb-2 required:*:">
            Source Name
            <span className="red-D">*</span>
          </label>
          <input
            className="body-N capitalize"
            name="sourceName"
            type="text"
            placeholder="enter name here....."
            value={data.sourceName}
            onChange={(e) => {
              const onlyAlphabets = e.target.value;
              handleChange(onlyAlphabets, "sourceName");
            }}
          />
          {error?.name && <span className="body-S red-D">{error?.name}</span>}
        </div>



        <div className="mt-8">
          <button type="submit" disabled={disable} className="save-button light-L head-5 green-bg-H">
            Add
          </button>
          <button type="button" onClick={handleClose} className="green-H ml-5">
            Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddLeadSourceModal;
